import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {FiAlertCircle} from "react-icons/fi";
import { useDispatch, useSelector } from 'react-redux';
import { agentSliceAction } from "../../../store/agentSlice";

const NoWrapCode = () => {
    const dispatch = useDispatch();
    const agentObj = useSelector((state:any)=>{return state.agentSlice.MissingWrapCode})
    const isMonitoring = useSelector((state:any)=>{return state.agentSlice.isMonitoring})
	const [show, setShow] = useState(true);
    useEffect(() => {
        if(!isMonitoring){    
            if(agentObj.MissingWrapCode){
                setShow(true);
            }
        }
    },[agentObj])
    const handleClose = () => {
        dispatch(agentSliceAction.setIsMissingWrapCode({MissingWrapCode: false}));
        setShow(false)
    }
    return (
        <React.Fragment>
            {(agentObj.MissingWrapCode)&&
				<Modal size="sm" show={show} backdrop="static" keyboard={false} centered>
					<Modal.Body>
						<div className='row'>
							<div className='col-12'>
								<div className='incomming-box text-center'>
									<div className='incomming-call-icon text-danger'><FiAlertCircle /></div>
									<h6 className='mt-3 mb-0 text-darkblue'>Please Fill the wrapcode for all contacts in the "Contacts handled" list</h6>
                                    <hr />
                                    <Button onClick={() => { handleClose() }} className='mw-100 me-2' variant="primary">
                                        OK
                                    </Button>
                                </div>                    
							</div>
						</div>
					</Modal.Body>
				</Modal>
			}
        </React.Fragment>
    )
}
export default NoWrapCode;
